var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "has-background-black-ter", attrs: { id: "timebar" } },
    [
      _c("div", [
        _c("div", { staticClass: "controls" }, [
          _c(
            "a",
            { on: { click: _vm.togglePlay } },
            [_c("b-icon", { attrs: { icon: _vm.icon, type: "is-white" } })],
            1
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "bar" },
          [
            _c("vue-slider", {
              attrs: {
                contained: "true",
                tooltip: "always",
                useKeyboard: true,
                adsorb: true,
                min: _vm.min,
                max: _vm.max,
                interval: _vm.runstep,
                tooltipFormatter: (val) => _vm.toDate(val, "DD.MM"),
                dotOptions: _vm.dotOptions,
                process: _vm.process,
                marks: _vm.ticks,
                processStyle: { background: "#ff9800" },
                tooltipStyle: { background: "#ff9800" },
              },
              on: { change: _vm.changed },
              model: {
                value: _vm.current,
                callback: function ($$v) {
                  _vm.current = $$v
                },
                expression: "current",
              },
            }),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }